import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

declare const tns: any;

@Component({ className: 'js-slider' })
export class SliderCustom {
	constructor(public element: HTMLElement) {
		this.initSlider(element);
		// Array.from(document.getElementsByClassName('js-slider')).forEach(elementSlider => {
		// });
	}

	private getIndexToGoTo(evt) {
		const prevIndex = evt.indexCached ? evt.indexCached : 0;
		if (evt.index > prevIndex) {
			return 'next';
		}
		if (evt.index < prevIndex) {
			return 'prev';
		}
		return undefined;
	}

	private initSlider(element: Element) {
		let customRefIndexChange = false;
		let customIndexChange = true;

		const slidesRef = document.querySelector('.js-slides-ref');
		const slider = tns({
			container: element.querySelector('.js-slides'),
			navContainer: element.querySelector('.js-dots'),
			controlsContainer: element.querySelector('.js-arrows'),
			arrowKeys: true,
			mouseDrag: true,
			loop: false,
			autoHeight: true,
			lazyload: true,
			lazyloadSelector: '--lazy',
		});
		if (slidesRef) {
			const sliderRef = tns({
				container: element.querySelector('.js-slides-ref'),
				controls: false,
				nav: false,
				mouseDrag: true,
				loop: false,
				autoHeight: true,
			});
			slider.events.on('indexChanged', (evt) => {
				if (customRefIndexChange == false) {
					const indexToGoTo = this.getIndexToGoTo(evt);
					if (indexToGoTo) {
						sliderRef.goTo(indexToGoTo);
					}
					customIndexChange = false;
					customRefIndexChange = false;
				}
			});
	
		}
		setTimeout(() => {
			slider.updateSliderHeight();
		}, 500);
		window.addEventListener('resize', debounce((e) => {
			slider.updateSliderHeight();
		}, 100));
	}
}
